import React from 'react';
import { observer } from 'mobx-react';
import { Flex, Box } from 'grid-styled';

import { ProgressBar } from 'react-fetch-progressbar';

import { Label } from '../styledSystem/Text';
import { BoxTemplate } from '../styledSystem/Box';
import Button from '../uic/Button';

class Confirmation extends React.Component {
    render() {
        const { confirm, uploadinprogress } = this.props;
        return (
            <React.Fragment>
                <Box>
                    <BoxTemplate height="15px" />
                    <BoxTemplate textalign="left" mt={'20px'} mb={'20px'}>
                        {uploadinprogress ? (
                            <Label textStyle="labelBold">
                                Resetting defaults, please wait...
                            </Label>
                        ) : (
                            <Label textStyle="labelBold">
                                {this.props.bodytext}
                            </Label>
                        )}
                    </BoxTemplate>
                    <BoxTemplate height="15px" />
                    {!uploadinprogress && (
                        <Flex justifyContent="flex-end">
                            <Button icon="close" onClick={this.props.close}>
                                Cancel
                            </Button>
                            <Button onClick={confirm} icon="check">
                                {this.props.confirmText}
                            </Button>
                        </Flex>
                    )}
                </Box>
                <ProgressBar style={{ backgroundColor: '#ee0606' }} />
            </React.Fragment>
        );
    }
}

export default observer(Confirmation);



// WEBPACK FOOTER //
// ./src/form/Confirmation.js